import { PROD_HOSTS } from '../consts'

export const isProd = () => PROD_HOSTS.includes(window.location.hostname)
